import { generateRequest } from './request.js';
import { AveRequestEvents } from '../events.js';
/**
 * Give the configured default environment and list all installed environments with the following information:
 * - name of the environment
 * - paths to preview images
 * - tags
 *
 * Example:
 * ```
 * [{
 *   "meta": {
 *     "name": "AVEListEnvironments",
 *     "type": "REQUEST",
 *     "lastUpdate": true
 *   },
 *   "data": {}
 * }]
 * ```
 */
export function generateListEnvironmentsRequest({ messageId } = {}) {
    return generateRequest({ messageId, name: AveRequestEvents.AVEListEnvironments });
}
/**
 * Select / change a specific environment.
 *
 * Limitations:
 * - Not available while an Environment is already loading.
 * - Not available when another car is loading.
 * - Not available when displaying the Driving Scene.
 * - Not available then rendering a sequence.
 *
 * Example:
 * ```
 * [{
 *   "meta": {
 *     "name": "AVESelectEnvironment",
 *     "type": "REQUEST",
 *     "lastUpdate": true
 *   },
 *   "data": {
 *     "environmentName": "ChicagoNight",
 *     "preserveCarAnimationStates": true,
 *     "loadingScreen": "Auto"
 *   }
 * }]
 * ```
 */
export function generateSelectEnvironmentRequest({ environmentName, preserveCarAnimationStates, loadingScreen, messageId }) {
    return generateRequest({
        messageId,
        name: AveRequestEvents.AVESelectEnvironment,
        data: { environmentName, preserveCarAnimationStates, loadingScreen }
    });
}
//# sourceMappingURL=environment.js.map